<template>
    <div class="input_container">
        <van-field v-model="localValue" type="number" :placeholder="labelText" @clear="onClear">
            <template #left-icon>
                <span class="left_icon">R$</span>
            </template>
            <template #right-icon>
                 <van-icon v-if="localValue" name="clear" class="custom-clear" @click.stop="onClear" />
            </template>
        </van-field>
    </div>
</template>

<script setup lang="ts">
import { ref, watch, defineProps, defineEmits } from 'vue'

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    labelText: {
        type: String,
        default: ''
    },
})

const emit = defineEmits(['update:modelValue', 'valueChanged'])

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
    localValue.value = newVal
})

watch(localValue, (val) => {
    emit('update:modelValue', val)
    emit('valueChanged', val)
})
const onClear = () => {
    localValue.value = ''
    emit('update:modelValue', '')
    emit('valueChanged', '')
}
</script>
<style scoped>
.input_container>>>.van-field {
    border-radius: 30px;
    background: #2C1D0F !important;
    border: 1px solid rgba(221, 122, 51, 1);
    color: #ffffffd9;
    padding: 12px 20px !important;
    margin-top: 10px;
}

.left_icon {
    color: rgba(255, 255, 255, 0.65);
    font-size: 17px;
    font-weight: bold;
    padding-right: 10px;
}

.input_container>>>.van-field__control {
    color: #fff !important;
}

.input_container>>>.van-field__control::placeholder {
    color: #ffffff40 !important;
}

.input_container>>>.van-field__clear {
    opacity: 0.5 !important;
}

.input_container img {
    width: 25px;
    opacity: 0.5;
}

.right_text {
    color: #ffffff73;
}

.extra_amount {
    color: #fff;
    padding: 0 5px;
}
</style>